import { useQuery } from '@connectrpc/connect-query'

import { getMe } from '@enechain/eposition-proto/bffportal/v1/user_service-UserService_connectquery'
import {
  EclearOption,
  PhysicalContractDeliveryType,
} from '@enechain/eposition-proto/bfftypes/v1/contract_pb'
import {
  OrganizationOptionCategory,
  getOrganizationOptionCategory,
} from '@enechain/eposition-ui/src/models/eclearOption'

import { Maybe } from '~/types/AdvancedTypes'

type Result = {
  organizationName: Maybe<string>
  optionCategory: Maybe<OrganizationOptionCategory>
  option: Maybe<EclearOption>
  deliveryType: Maybe<PhysicalContractDeliveryType>
  organizationId: Maybe<string>
  memberId: Maybe<string>
}

export function useGetMe(): Result {
  const { data } = useQuery(getMe, {}, { staleTime: Infinity })

  return {
    organizationName: data?.me?.organizationName,
    organizationId: data?.me?.organizationId,
    optionCategory:
      data?.me?.contract?.eclearOption !== undefined
        ? getOrganizationOptionCategory(data.me.contract.eclearOption)
        : undefined,
    option: data?.me?.contract?.eclearOption,
    deliveryType: data?.me?.contract?.deliveryType,
    memberId: data?.me?.memberId,
  }
}
